import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import client from '../../api/client';

export const fetchAvailability = createAsyncThunk('availability/fetch', async () => {
  const { data } = await client.get('/auth/availability/');
  return data.results || data;
});

export const setMyStatus = createAsyncThunk('availability/setMine', async (status) => {
  const { data } = await client.patch('/auth/availability/me/', { status });
  return data;
});

const availabilitySlice = createSlice({
  name: 'availability',
  initialState: { list: [], myStatus: null, loading: false },
  reducers: {
    setMine(state, action) {
      state.myStatus = action.payload.status;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAvailability.fulfilled, (state, a) => { state.list = a.payload; })
      .addCase(setMyStatus.fulfilled, (state, a) => { state.myStatus = a.payload.status; });
  },
});

export const { setMine } = availabilitySlice.actions;
export default availabilitySlice.reducer;
